import React, { useEffect, useState } from 'react';
import NavBar from "../NavBar/NavBar";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Footer from "../Footer/Footer";
import { InputNumber } from "primereact/inputnumber";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useNavigate} from "react-router-dom";
import {Button} from "primereact/button";

const CartDetails = () => {
    const navigate = useNavigate();
    const isMobile = window.innerWidth <= 440;
    const [dataArray, setDataArray] = useState([]);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const showSnackbar = (message, severity = 'success') => {setSnackbar({ open: true, message, severity });};
    const handleCloseSnackbar = () => {setSnackbar({ ...snackbar, open: false });};
    const loadCartData = () => {
        const dataItems = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key.startsWith("cartItem-")) {
                try {
                    const item = localStorage.getItem(key);

                    if (item && item.startsWith("{")) {
                        dataItems.push(JSON.parse(item));
                    }
                } catch (err) {
                    console.warn(`Could not parse localStorage item for key: ${key}`, err);
                }
            }
        }
        setDataArray(dataItems);
    };

    useEffect(() => {
        loadCartData();
    }, []);

    const handleDelete = (productNameToDelete) => {
        const keysToDelete = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key.startsWith("cartItem-")) {
                try {
                    const item = JSON.parse(localStorage.getItem(key));

                    if (item?.productName === productNameToDelete) {
                        keysToDelete.push(key);
                    }
                } catch (err) {
                    console.warn(`Error parsing key: ${key}`, err);
                }
            }
        }

        keysToDelete.forEach(key => localStorage.removeItem(key));
        loadCartData();
        showSnackbar("Item deleted successfully", "error");
    };

    const calculateEstimatedTotal = () => {
        return dataArray.reduce((acc, item) => {
            const price = parseFloat(item.productPrice.replace("Rs.", "").replace(/,/g, "").trim());
            const quantity = item.productQuantity;
            return acc + (price * quantity);
        }, 0);
    };


    return (
        <div className="bg-offWhite">
            <NavBar />
            <div style={{ paddingTop: "13rem" }}>
                {dataArray.length === 0 ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: "70vh" }}>
                        <div className="text-center">
                            <p className="fs-16 mb-4">Your Cart is Empty</p>
                            <button className="banner-btn" onClick={() => navigate("/products")}>Start Shopping</button>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="d-flex justify-content-between align-items-center px-lg-5 mx-lg-5  mx-md-5 cart-header custom-padding-for-cart">
                            <h2 className="text-green fw-bold pt-5 pb-4 m-0">YOUR CART</h2>
                            <a href="/products" className="text-decoration-none"><button className="btn btn-outline-success">Continue Shopping</button></a>
                        </div>
                <div className="px-lg-5 mx-lg-5  mx-md-5 custom-padding-for-cart cart-table-wrapper">
                    <DataTable value={dataArray} tableStyle={{ minWidth: isMobile ? '0' : '50rem' }}>
                        {!isMobile && (
                                <Column
                                    header="PRODUCT"
                                    body={(rowData) => (
                                        <div className="d-flex align-items-center">
                                            <img src={rowData.productImage} style={{ width: '50px', marginRight: '1rem' }} loading="lazy" />
                                        </div>
                                    )}
                                />
                        )}
                        {!isMobile && (
                                <Column
                                    header="DETAIL"
                                    body={(rowData) => (
                                        <div>
                                            <div><strong>{rowData.productName}</strong></div>
                                            <div>{rowData.productPrice}</div>
                                            <div>Size: {rowData.productSize}</div>
                                            <div>Color: {rowData.productColor}</div>
                                        </div>
                                    )}
                                />
                        )}
                        {!isMobile && (
                                <Column
                                    field="productQuantity"
                                    header="QUANTITY"
                                    body={(rowData, { rowIndex }) => (
                                        <>
                                            <InputNumber
                                                value={rowData.productQuantity}
                                                onValueChange={(e) => {
                                                    const updatedDataArray = [...dataArray];
                                                    const updatedItem = {
                                                        ...updatedDataArray[rowIndex],
                                                        productQuantity: e.value
                                                    };
                                                    updatedDataArray[rowIndex] = updatedItem;
                                                    setDataArray(updatedDataArray);
                                                    for (let i = 0; i < localStorage.length; i++) {
                                                        const key = localStorage.key(i);
                                                        if (key && key.startsWith("cartItem-")) {
                                                            try {
                                                                const item = JSON.parse(localStorage.getItem(key));
                                                                if (item?.productName === updatedItem.productName) {
                                                                    localStorage.setItem(key, JSON.stringify(updatedItem));
                                                                    break;
                                                                }
                                                            } catch (err) {
                                                                console.warn(`Error updating localStorage for key: ${key}`, err);
                                                            }
                                                        }
                                                    }
                                                }}
                                                showButtons
                                                buttonLayout="horizontal"
                                                step={1}
                                                min={1}
                                                className="custom-quantity-input"
                                                decrementButtonClassName="custom-quantity-btn"
                                                incrementButtonClassName="custom-quantity-btn"
                                                incrementButtonIcon={<span style={{ fontSize: '1.2rem' }}>+</span>}
                                                decrementButtonIcon={<span style={{ fontSize: '1.2rem' }}>−</span>}
                                            />
                                            <FontAwesomeIcon
                                                cursor={"pointer"}
                                                className={"text-danger ms-3"}
                                                icon={faTrashCan}
                                                onClick={() => handleDelete(rowData.productName)}
                                            />
                                        </>
                                    )}
                                />
                        )}
                        {!isMobile && (
                                <Column
                                    header="TOTAL"
                                    body={(rowData) => {
                                        const price = parseFloat(
                                            rowData.productPrice.replace("Rs.", "").replace(/,/g, "").trim()
                                        );
                                        const quantity = rowData.productQuantity;
                                        const total = price * quantity;
                                        return (
                                            <span className="fw-bold text-danger">
                                             Rs. {total.toLocaleString()}
                                     </span>
                                        );
                                    }}
                                />
                        )}
                        {isMobile && (
                            <Column
                                header="PRODUCT"
                                body={(rowData, { rowIndex }) => (
                                    <div className="cart-card">
                                        <div className="cart-top">
                                            <img src={rowData.productImage} className="cart-img" loading="lazy"/>
                                            <div className="cart-detail">
                                                <div><strong>{rowData.productName}</strong></div>
                                                <div>{rowData.productPrice}</div>
                                                <div>Size: {rowData.productSize}</div>
                                                <div>Color: {rowData.productColor}</div>
                                            </div>
                                            {/*<span className="fw-bold text-danger ms-3">*/}
                                            {/*    Rs. {(*/}
                                            {/*    parseFloat(rowData.productPrice.replace("Rs.", "").replace(/,/g, "").trim()) **/}
                                            {/*    rowData.productQuantity*/}
                                            {/*).toLocaleString()}*/}
                                            {/*</span>*/}
                                        </div>
                                        <div className="cart-bottom">
                                                        <InputNumber
                                                            value={rowData.productQuantity}
                                                            onValueChange={(e) => {
                                                                const updatedDataArray = [...dataArray];
                                                                const updatedItem = {
                                                                    ...updatedDataArray[rowIndex],
                                                                    productQuantity: e.value
                                                                };
                                                                updatedDataArray[rowIndex] = updatedItem;
                                                                setDataArray(updatedDataArray);
                                                                for (let i = 0; i < localStorage.length; i++) {
                                                                    const key = localStorage.key(i);
                                                                    if (key && key.startsWith("cartItem-")) {
                                                                        try {
                                                                            const item = JSON.parse(localStorage.getItem(key));
                                                                            if (item?.productName === updatedItem.productName) {
                                                                                localStorage.setItem(key, JSON.stringify(updatedItem));
                                                                                break;
                                                                            }
                                                                        } catch (err) {
                                                                            console.warn(`Error updating localStorage for key: ${key}`, err);
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            showButtons
                                                            buttonLayout="horizontal"
                                                            step={1}
                                                            min={1}
                                                            className="custom-quantity-input"
                                                            decrementButtonClassName="custom-quantity-btn"
                                                            incrementButtonClassName="custom-quantity-btn"
                                                            incrementButtonIcon={<span style={{ fontSize: '1.2rem' }}>+</span>}
                                                            decrementButtonIcon={<span style={{ fontSize: '1.2rem' }}>−</span>}
                                                        />
                                                        <FontAwesomeIcon className="text-danger ms-3" icon={faTrashCan} onClick={() => handleDelete(rowData.productName)}/>
                                        </div>
                                    </div>
                                )}
                            />
                        )}
                        {isMobile && (
                            <Column
                                header="TOTAL"
                                body={(rowData) => {
                                    const price = parseFloat(
                                        rowData.productPrice.replace("Rs.", "").replace(/,/g, "").trim()
                                    );
                                    const quantity = rowData.productQuantity;
                                    const total = price * quantity;
                                    return (
                                        <span className="fw-bold text-danger">Rs. {total.toLocaleString()}</span>
                                    );
                                }}
                            />
                        )}
                    </DataTable>
                </div>
                <div className="d-flex flex-column align-items-end px-lg-5 mx-lg-5 py-lg-4  mx-md-5 py-md-4">
                    <div className="fs-15 fw-bold custom-fs-15-cart-details">
                        <span className="text-dark me-2">Estimated Total:</span>{' '}
                        <span className="text-danger">Rs. {calculateEstimatedTotal().toLocaleString()} PKR</span>
                    </div>
                    <div className="fs-10 my-4 custom-fs-11-checkout">Taxes, discounts and shipping calculated at checkout.</div>
                    <div className="m-0">
                        <Button label="Check out" severity="info" filled  onClick={() => navigate('/checkout')} className='text-white br-10'/>
                    </div>
                </div>
                    </>
                )}
            </div>
            <Footer />
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <MuiAlert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }} elevation={6} variant="filled">
                    {snackbar.message}
                </MuiAlert>
            </Snackbar>
        </div>
    );
};
export default CartDetails;
